import { useCallback, useEffect, useMemo, useState } from "react";
import { message } from "antd";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../../../hooks";
import { ActiveSessionApi } from "../../../../api/revi/activeSessionApi";

const api = new ActiveSessionApi();

export function useTherapistTerapiaController() {
  const navigate = useNavigate();
  // Los avisos de este controlador se leen en pantalla, asi que tambien son
  // interfaz aunque no vivan en un componente.
  const { t } = useTranslation("therapy");
  const { accessToken } = useAuth();

  const [loading, setLoading] = useState(true);
  const [sessions, setSessions] = useState([]);

  const [openWizard, setOpenWizard] = useState(false);
  const [search, setSearch] = useState("");
  const [deletingId, setDeletingId] = useState(null);

  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10,
    totalDocs: 0,
    totalPages: 1,
  });

  const load = useCallback(async () => {
    try {
      setLoading(true);

      const res = await api.listMySessions(accessToken, {
        page: pagination.page,
        limit: pagination.limit,
        search,
      });

      setSessions(res?.sessions || []);
      setPagination((p) => ({
        ...p,
        ...(res?.pagination || {}),
      }));
    } catch (e) {
      message.error(e?.message || t("sesiones.avisos.errorCargar"));
      setSessions([]);
    } finally {
      setLoading(false);
    }
  }, [accessToken, pagination.page, pagination.limit, search, t]);

  useEffect(() => {
    if (!accessToken) return;
    load();
  }, [accessToken, load]);

  const onReload = () => load();
  const onDeleteSession = useCallback(
    async (sessionId) => {
      try {
        setDeletingId(sessionId);
        await api.deleteSession(accessToken, sessionId);
        message.success(t("sesiones.avisos.borrada"));
        await load();
      } catch (e) {
        message.error(e?.message || t("sesiones.avisos.errorBorrar"));
      } finally {
        setDeletingId(null);
      }
    },
    [accessToken, load, t],
  );

  const onCreated = (sessionId) => {
    setOpenWizard(false);
    navigate(`/portal/therapist/terapia/sesion/${sessionId}`);
  };

  const pag = useMemo(
    () => ({
      ...pagination,
      onChange: (page) => setPagination((p) => ({ ...p, page })),
    }),
    [pagination],
  );

  return {
    loading,
    sessions,
    pagination: pag,
    search,
    setSearch,
    openWizard,
    setOpenWizard,
    onReload,
    onCreated,
    deletingId,
    onDeleteSession,
  };
}
